import { useQuery } from "@tanstack/react-query";
import { roleApi } from "@repo/api";
import { sideNavKeys } from "../queryKeys";

export const useGetCurrentUserRoles = () => {
  const { data, isLoading, isError, error, isSuccess } = useQuery({
    queryKey: [sideNavKeys.currentUserRoles()],
    queryFn: () => roleApi.getCurrentUserRoles(),
  });

  return { data, isLoading, isError, error, isSuccess };
};
